module.exports = __webpack_public_path__ + "img/sponsorM08.35376a69.png";